































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import Plant from "@/domainObjects/Plant";
import HoldTicket from "@/domainObjects/hold/HoldTicket";
import {mapGetters} from "vuex";
import TicketService from "@/services/TicketService";
import LoadingIndicator from "@/view/shared-components/LoadingIndicator.vue";
import Fields from "@/domainObjects/Fields";
import LoadingActions from "@/store/actions/loading";

@Component({
    name: 'HoldTicketTable',
    components: {LoadingIndicator},
    computed: {
        ...mapGetters(['getGroups']),
    }
})
export default class HoldTicketTable extends Vue {
    @Prop({required: false}) searchJSON!: String;

    private holdTickets: HoldTicket[] = [];
    private fields:Fields[] = [];
    private currentPage:number = 0;
    private perPage:number = 0;
    private totalRows:number = 0;
    private filter:string = '';
    private hover:boolean = true;
    private pageOptions:number[] = [];
    private sortBy:string = '';
    private sortDesc:boolean = true;
    private busy: boolean = false;
    private tableLayout: boolean = false;
    private unsecureServerUrl: string;
    private downloading: boolean = false;
    private error: boolean = false;
    private windowWidth: number = 0;

    @Watch('searchJSON', { immediate: true })
    onPropertyChanged(newvalue: string, oldvalue: string){
        if (newvalue){
            this.fetchHoldTicketsBySearch();
        }
        if (newvalue == undefined && oldvalue == undefined){
            this.$router.push('/search-hold-ticket')
        }
    }

    constructor() {
        super();
        this.fields = [
            { key: 'holdTicketId', label: 'Ticket #', sortable: true, sortDirection: 'desc' },
            { key: 'status.desc', label: 'Status', sortable: true, sortDirection: 'desc'},
            { key: 'cparNumber', label: 'CAPA #', sortable: true, sortDirection: 'desc'},
            { key: 'materialDesc', label: 'Material Desc.', sortable: true, sortDirection: 'desc' },
            { key: 'materialNumber', label: 'Material No.', sortable: true, sortDirection: 'desc'},
            { key: 'defect.desc', label: 'Reason Code', sortable: true, sortDirection: 'desc'},
            { key: 'comments', label: 'Desc. of Non-conf', sortable: true, sortDirection: 'desc', },
            { key: 'daysOpen', label: 'Days Open', sortable: true, sortDirection: 'desc' },
            { key: 'plant.desc', label: 'Plant', sortable: true, sortDirection: 'desc' },
            { key: 'salesOrderNumber', label: 'Sales Order Number', sortable: true, sortDirection: 'desc'},
            { key: 'labor', label: 'Labor Hours', sortable: true, sortDirection: 'desc'},
            { key: 'actions', label: 'Options', sortable: false, sortDirection: 'desc' }
        ];
        this.currentPage = 1;
        this.perPage = 25;
        this.totalRows = this.holdTickets.length;
        this.filter = "";
        this.hover = true;
        this.pageOptions = [ 5, 10, 25, 50, 100 ];
        this.sortBy = 'holdTicketId';
        this.sortDesc = true;
        this.unsecureServerUrl = TicketService.getUnsecureServerUrl();
    }

    fetchHoldTicketsBySearch(){
        this.$store.dispatch(LoadingActions.LOADING, true);
        this.busy = true;
        this.holdTickets = [];
        TicketService.getHoldTicketsBySearch(this.searchJSON).then((response) => {
            if (response.status != 200){
                this.error = true;
                this.busy = false;
            } else {
                for ( let readHoldTicket of response.data ) {
                    let ticket = new HoldTicket();
                    ticket.initFromObject(readHoldTicket);
                    this.holdTickets.push(ticket);
                }
                this.busy = false;
            }
            this.$store.dispatch(LoadingActions.LOADING, false);
        }).catch((error)=>{

            this.$router.push('/search-hold-ticket')
        });
    }

    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }

    destroyed(){
        window.removeEventListener('resize', this.handleResize)
    }

    handleResize(){
        this.tableLayout = window.innerWidth < 992;
        this.windowWidth = window.innerWidth;
    }

    onFiltered( filteredItems ) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
    }

    toggleBusy() {
        this.busy = !this.busy;
    }

    changeLayout(){
        this.tableLayout = !this.tableLayout;
    }

    openCsvFile(result, csvFileName){
        if (window.navigator.msSaveBlob) {
            //Internet Explorer
            window.navigator.msSaveBlob(new Blob([result]), csvFileName);
            // @ts-ignore
        } else if (window.webkitURL != null) {
            //Google Chrome and Mozilla Firefox
            let a = document.createElement("a");
            result = encodeURIComponent(result);
            a.href = "data:application/csv;charset=UTF-8," + result;
            a.download = csvFileName;
            a.click();
        } else {
            //Everything Else
            window.open(result);
        }
    }

    generateHoldExcelReport(){
        this.downloading = true;
        TicketService.generateHoldExcelReport(this.searchJSON).then((response)=>{
            this.openCsvFile(response.data, "HoldTicketSearchResults.csv");
            this.downloading = false;
        }).catch((error) => {

            this.$router.push('/search-hold-ticket')
            alert('error downloading excel file, search criteria may be malformed');
        });
    }

    view(ticketId){
        let routeData = this.$router.resolve({name: 'routeName', params: { holdTicketId: ticketId }})
        window.open(routeData.href, '_blank')
    }
}

